import { useMemo } from 'react';
import { useMedia } from 'react-use-media';
import { MessageTemplateType } from '~/types/models';

type UseNextGenTemplateArgs = {
  templateType: MessageTemplateType;
  canAccessNextGenTemplate: boolean;
};

export default function useNextGenTemplate({
  templateType,
  canAccessNextGenTemplate,
}: UseNextGenTemplateArgs): boolean {
  const isMobile = useMedia({
    maxWidth: 768,
  });

  const showNextGenLayout = useMemo(() => {
    return (
      isMobile ||
      (canAccessNextGenTemplate && templateType === MessageTemplateType.NextGen)
    );
  }, [isMobile, canAccessNextGenTemplate, templateType]);

  return showNextGenLayout;
}
